<template>
  <el-dialog
    :visible="true"
    width="500px"
    @close="$router.replace('/processes/packings')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
    </div>
    <el-tabs
      v-model="activeName"
      v-loading="loading">
      <el-tab-pane
        label="Alapadatok"
        name="1">
        <el-table
          :data="packingData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.tagType || 'danger'"
                size="small"
                v-if="scope.row.tag"
              >
                {{ scope.row.value }}
              </el-tag>
              <span v-if="!scope.row.tag" style="word-break: normal;">{{ scope.row.value }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        v-if="packing.product.ingredients.length"
        label="Összetevők"
        name="2"
      >
        <el-table
          :data="packing.product.ingredients"
          border
        >
          <el-table-column
            prop="ingredient.name"
            label="Összetevő"
            width="300"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.ingredient.name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="Mennyiség"
          >
            <template slot-scope="scope">
              {{ scope.row.count * packing.count }} db
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="$router.replace('/processes/packings')"
        type="primary"
      >
        Vissza
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

  export default {
    props: ['packingId'],
    data() {
      return {
        activeName: '1',
        title: 'Betöltés folyamatban...',
        loading: false,
        packing: {
          product: {
            ingredients: []
          }
        },
        packingData: [],
      };
    },

    async mounted() {
      await this.fetchData();
    },
    methods: {
      async fetchData() {
        this.loading = true;
        this.packing = await this.$store.dispatch('packing/fetch', this.packingId);
        this.title = this.packing.product.name;
        this.packingData = [
          {
            label: 'Termék',
            value: this.packing.product && this.packing.product.name,
          },
          {
            label: 'Típus',
            value: this.packing.type === 'inPacking' ? 'Becsomagolás' : 'Kicsomagolás',
          },
          {
            label: 'Raktár',
            value: this.packing.storage && this.packing.storage.name,
          },
          {
            label: 'Mennyiség',
            value: this.packing.count || '',
          },
          {
            label: 'Rögzítette',
            value: this.packing.creator_user && this.packing.creator_user.last_name + ' ' + this.packing.creator_user.first_name
          },
          {
            label: 'Létrehozva',
            value: this.$options.filters.dateTime(this.packing.created_at)
          },
        ];
        this.loading = false;
      },
    },
  };
</script>
